<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý danh sách bản tin phát thanh</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                        <label>Tên bản tin:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Tên bản tin..." v-model="search.cTenBanTin" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
                        <label>Trạng thái:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                                    <el-option label="Tất cả" value="" selected></el-option>
                                    <el-option label="Hoạt động" value="1" selected></el-option>
                                    <el-option label="Đã xóa" value="0" selected></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                                        class="fa fa-search"></i></el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <div class="body-function">
                    <div class="col-md-6">
                        <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd"
                            data-bs-toggle="modal" data-bs-target="#modal_hotline" :disabled="!handleCheckPerms('za:audio:add')">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm bản tin </span>
                        </el-button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" fit stripe highlight-current-row>
                        <el-table-column prop="nMaBanTin" label="Mã" width="100" align="center"></el-table-column>
                        <el-table-column prop="cTenBanTin" label="Tên bản tin" min-width="150"></el-table-column>
                        <el-table-column prop="dNgayDang" label="Ngày đăng" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayDang) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayTao) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.nTrangThai == 1" size="small">Hoạt Động</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTrangThai == 0" size="small">Đã xóa</el-tag>
                            </template>
                        </el-table-column>
                        <!-- Button hành động -->
                        <el-table-column width="200" label="Hành động" align="center">
                            <template #default="scope">
                                <el-button
                                    plain
                                    type="success"
                                    title="Nghe bản tin"
                                    @click="handlePlayVideo(scope.row)"
                                    >
                                    <i class="fas fa-play"></i>
                                </el-button>
                                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('za:audio:edit')"
                                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal"
                                    data-bs-target="#modal_hotline">
                                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                                </el-button>

                                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('za:audio:delete')"
                                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_hotline" ref="hotlineModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_hotline_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">{{ !operation ? "Thêm bản tin " : "Cập nhật bản tin " }}</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px" class=" d-flex flex-column">
                            <el-form-item label="Tên bản tin" prop="cTenBanTin">
                                <el-input v-model="formData.cTenBanTin" />
                            </el-form-item>
                            <el-form-item label="Ngày đăng" prop="dNgayDang">
                                <el-date-picker
                                    v-model="formData.dNgayDang"
                                    type="date"
                                    placeholder="Ngày đăng"
                                    format="DD/MM/YYYY"
                                />
                            </el-form-item>
                            <el-form-item label="File bản tin" prop="attachmentFile">
                                <el-upload
                                    ref="uploadAttachment"
                                    class="upload-demo"
                                    action="#"
                                    :auto-upload="false"
                                    :file-list="attachmentFile"
                                    accept=".wav, .mp3"
                                    :on-change="handleChangeAttachment"
                                    :on-remove="handleRemoveAttachment"
                                >
                                    <template #trigger>
                                    <el-button type="primary">Chọn file</el-button>
                                    </template>

                                    <template #tip>
                                        <div class="el-upload__tip">
                                            Chọn file wav/mp3 có kích thước dưới 10mb
                                        </div>
                                    </template>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Thêm</el-button>
                            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Lưu</el-button>
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog
            v-model="videoDialogVisible"
            width="450px"
            destroy-on-close
            >
            <template #header>
                <strong style="font-size: 18px;">Nghe bản tin</strong>
            </template>

            <video
                v-if="videoUrl"
                :src="videoUrl"
                controls
                style="width:100%; max-height:70vh"
            />
        </el-dialog>
    </div>
</template>
<script>
import { ZaAudio } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";
import { baseUrl } from "@/utils/global";


export default {
    name: 'service',
    data() {
        return {
            perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [], 
            search: {
                cTenBanTin: "",
                nTinhTrang: "",
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },
            formData: {
                cTenBanTin: "",
                nTinhTrang: 1,
                dNgayDang: "",
                cFile: "",
                attachmentFile: [],
            },
            rules: {
                cTenBanTin: [{ required: true, message: "Xin vui lòng điền tên bản tin", trigger: "blur" }],
                dNgayDang: [{ required: true, message: "Xin vui lòng điền ngày đăng", trigger: "blur" }],
                attachmentFile: [
                    {
                        required: true, message: 'Xin vui lòng chọn file bản tin', trigger: 'change', validator: (rule, value, callback) => {
                        if (this.attachmentFile.length === 0) {
                            callback(new Error('Xin vui lòng chọn file bản tin'));
                        } else {
                            callback();
                        }
                        }
                    },
                ],
            },
            tableData: {
                content: []
            },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore(),
            attachmentFile: [],
            videoUrl: "",
            videoDialogVisible: false
        }
    },
    methods: {
        handlePlayVideo(row) {
            this.videoUrl = baseUrl + "/view" + row.cFile
            this.videoDialogVisible = true
        },
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenAdd() {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = false
            this.formData = {
                cTenBanTin: "",
                nTinhTrang: 1,
                dNgayDang: new Date(),
                cFile: "",
                attachmentFile: [],
            }
            this.attachmentFile = []
        },
        async handleOpenEdit(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({}, val)
            this.attachmentFile = []
            if (val.cFile) {
                this.isLoading = true
                await this.addAttachmentFromURL(baseUrl + val.cFile)
                this.isLoading = false
            }
        },
        handleClose() {
            this.$refs.formData.resetFields()
            this.modalVisible = false
            hideModal(this.$refs.hotlineModalRef)
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa bản tin này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    this.store.dispatch(ZaAudio.delete, val).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: "Xóa bản tin thành công", type: "success" });
                            this.handleFindPage()
                        } else {
                            ElMessage({ message: res.msg, type: "error" });
                        }
                    }).catch((error) => {
                        ElMessage({ message: "Xóa bản tin thất bại", type: "error" });
                    })
                }).catch(() => {

                })
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTieuDe: {value:this.search.cTenBanTin},
                nTinhTrang: {value:this.search.nTinhTrang},
            }
            this.store.dispatch(ZaAudio.findPage, this.pageRequest).then(res => {                
                if (res.code == 200 && res.data) {
                    this.tableData = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm bản tin thất bại", type: "error" });
            })
        },
        handleSave() {
            this.$refs.formData.validate((valid) => {
                if (valid)
                    this.$confirm("Bạn có muốn lưu bản tin này không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    })
                    .then(() => {                            
                        this.isLoading = true
                        const formData = new FormData()
                        if (this.attachmentFile.length > 0) {
                            if (this.attachmentFile[0].status == "ready") {
                                formData.append('file', this.attachmentFile[0].raw)
                            }
                        }
                        formData.append("record", new Blob([JSON.stringify(this.formData)], { type: "application/json" }))

                        this.store.dispatch(this.operation ? ZaAudio.update : ZaAudio.save, formData).then(res => {
                            if (res.code == 200) {
                                ElMessage({ message: this.operation ? "Cập nhật bản tin thành công" : "Thêm bản tin thành công", type: "success" });
                                this.handleClose()
                                this.handleFindPage()
                            }
                            else {
                                ElMessage({ message: res.msg, type: "error" });
                            }
                            this.isLoading = false
                        }).catch((error) => {
                            ElMessage({ message: this.operation ? "Cập nhật bản tin thất bại" : "Thêm bản tin thât bại", type: "error" });
                            this.isLoading = false
                        })

                    }).catch(ex => {
                        console.log(ex);
                    })
            })
        },

        async handleChangeAttachment(file, attachmentFile) {
            this.attachmentFile = [file]
            this.formData.attachmentFile = this.attachmentFile
        },

        handleRemoveAttachment(file, attachmentFile) {
            this.attachmentFile = []
            this.formData.attachmentFile = this.attachmentFile
        },

        async addAttachmentFromURL(url) {
            const response = await fetch(url);
            if (!response.ok) throw new Error('Failed to fetch file');
            const blob = await response.blob();

            const filename = url.split('/').pop().split('?')[0] || `file-${Date.now()}`;
            const file = new File([blob], filename, { type: blob.type || 'application/octet-stream' });

            this.attachmentFile.push({
                name: file.name,
                url: URL.createObjectURL(file),
                status: 'success',
                uid: Date.now(),
                raw: file
            });
        },

        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        },
        handleCheckPerms(val){
            return this.perms.includes(val)
        }
    },
    mounted() {
        this.handleFindPage()
    }
};
</script>
<style lang="scss"></style>